import Api from '@/project/http/Api.service';
import dictionaryService from '@/core/translation/dictionary.service';
import { WebInquiryBlockViewModel } from '@/types/contentServerContract';

interface Fields {
    brand: string;
    header: string;
    subheader: string;
    commentInputHeader: string;
    commentInputPlaceholderText: string;
    contactConfirmationText: string;
    ctaText: string;
    receiptHeader: string;
    receiptBodyText: string;
}
export function useWebInquiryActions() {
    async function loadWebInquiryActions(id: string) : Promise<WebInquiryBlockViewModel> {
        return await Api.webInquiries.getWebInquiries(id);
    }

    function formatFields(webInquiryFields: Fields): {
        heading: string;
        bodyText: string;
        commentInputHeader: string;
        commentInputPlaceholderText: string;
        contactConfirmationText: string;
        ctaText: string;
        successHeading: string;
        successBodyText: string;
    } {
        return {
            heading: dictionaryService.formatNamed(webInquiryFields.header, { brand: webInquiryFields.brand }),
            bodyText: dictionaryService.formatNamed(webInquiryFields.subheader, { brand: webInquiryFields.brand }),
            commentInputHeader: dictionaryService.formatNamed(webInquiryFields.commentInputHeader, { brand: webInquiryFields.brand }),
            commentInputPlaceholderText: dictionaryService.formatNamed(webInquiryFields.commentInputPlaceholderText, { brand: webInquiryFields.brand }),
            contactConfirmationText: dictionaryService.formatNamed(webInquiryFields.contactConfirmationText, { brand: webInquiryFields.brand }),
            ctaText: dictionaryService.formatNamed(webInquiryFields.ctaText, { brand: webInquiryFields.brand }),
            successHeading: dictionaryService.formatNamed(webInquiryFields.receiptHeader, { brand: webInquiryFields.brand }),
            successBodyText: dictionaryService.formatNamed(webInquiryFields.receiptBodyText, { brand: webInquiryFields.brand }),
        };
    }

    return {
        loadWebInquiryActions,
        formatFields
    };
}
